import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './icons/Icons';
import { useLanguage } from '../data/i18n';
export function Guarantee() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full border-y border-white/10 bg-white py-24 sm:py-28 text-black" data-id="element-44" data-mp="223y2kzo0jtgf">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} className="mx-auto max-w-3xl px-6 text-center" data-id="element-45" data-mp="1x42054uysa2z">
        <span className="mx-auto flex h-14 w-14 items-center justify-center border border-black/30" data-id="element-46" data-mp="14dl4pk0e8ico">
          <ShieldIcon className="w-7 h-7 text-black" data-id="element-47" data-mp="1j6dg1z8q16yz" />
        </span>
        <h2 className="mt-8 font-display text-5xl sm:text-6xl tracking-[0.05em]" data-id="element-48" data-mp="1ec97xcnpyswb">{t.guarantee.title}</h2>
        <p className="mt-6 font-body text-base sm:text-lg font-light leading-relaxed text-black/70" data-id="element-49" data-mp="qmonsqftxplg">
          {t.guarantee.body}
        </p>
        <p className="mt-6 font-sans text-[11px] uppercase tracking-[0.3em] text-black" data-id="element-50" data-mp="ozrpkf7rqm1x">{t.guarantee.kicker}</p>
      </motion.div>
    </section>;
}